// A stable per-device/browser identifier used for the course device-limit check
// (see docs/web-otp-auth-v2.md §3/§4). Generated once, persisted in localStorage,
// and never changes for this browser. It is sent at OTP verify (baked into the
// JWT) and as an `X-Device-Id` header on authenticated requests so content
// endpoints can enforce the limit. Keep the value stable per device.

const DEVICE_ID_KEY = "device_id";

const isBrowser = () => typeof window !== "undefined";

const generate = (): string => {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID.
  return "web-xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Return the stable device id for this browser, creating and persisting one on
 * first use. Returns `null` only outside a browser (SSR) or when localStorage is
 * unavailable, in which case the device-limit check is skipped server-side.
 */
export const getDeviceId = (): string | null => {
  if (!isBrowser()) return null;
  try {
    let id = window.localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = generate();
      window.localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    // localStorage can throw in private mode or when the quota is exceeded.
    return null;
  }
};
